import SBEditable from "../../../components/sbEditable/sbEditable";
import ListingHeader from "../../../components/listingHeader/listingHeader";
import ArticleAsideCard from "../../../components/articleAsideCard/ArticleAsideCard";

import styles from "./articleListingByCategoryWidget.module.scss";
import { useStoryblokArticlesByCategoryWidget } from "../../../hooks/useStoryblokArticlesByCategoryWidget";

/// >> Blok:articlelistingwidget
// headline:text
// category:text
function ArticleListingByCategoryWidget({ blok, category }) {
  const [articles, isLoading] = useStoryblokArticlesByCategoryWidget(category);

  if (!isLoading && articles.length === 0) {
    return null;
  }

  return (
    <SBEditable blok={blok}>
      <ListingHeader>
        <h3>{blok.headline}</h3>
      </ListingHeader>
      <ul className={styles.wrapper}>
        {isLoading ? <div className="loader centered" /> : null}
        {articles.map((a, idx) => {
          return (
            <li key={a.uuid}>
              <ArticleAsideCard
                slug={a.slug}
                thumbnail={a.content.thumbnail}
                authors={a.content.authors}
                title={a.content.headline}
                date={a.content.created_at}
                article_type={a.content.article_type}
                comment_count={5}
                enable_comments={a.content.has_comments}
                enable_social_sharing={a.content.has_social_sharing}
                use_legacy_thumbnail_background={
                  a.content.legacy_thumbnail_background
                }
              />
              {idx < articles.length - 1 ? <hr /> : null}
            </li>
          );
        })}
      </ul>
    </SBEditable>
  );
}

export default ArticleListingByCategoryWidget;
